import { useAuthStore } from '../../stores/auth';
import { useTenantSettings } from '../../tenant/useTenantSettings';

export function isAdminUser(user) {
  return user?.role === 'admin' || user?.role === 'super_admin';
}

/** Admins can always write; students only where the tenant allows it. Null while loading. */
export function useCanWritePosts() {
  const user = useAuthStore((state) => state.user);
  const settings = useTenantSettings();
  if (!settings) return null;
  return isAdminUser(user) || settings.features.blogs.allowStudentPosts;
}
